import { Transition } from '@headlessui/react';

import type { FunctionComponent } from 'react';
import type { TypeStepFormProps } from './types';

/**
 * StepForm
 */
export const StepForm: FunctionComponent<TypeStepFormProps> = ({
  className,
  show,
  enter = 'ease-out duration-300',
  enterFrom = 'opacity-0 translate-y-0 sm:translate-y-0 sm:scale-95',
  enterTo = 'opacity-100 translate-y-0 sm:scale-100',
  children,
}: TypeStepFormProps) => (
  <Transition
    show={show}
    unmount={false}
    enter={enter}
    enterFrom={enterFrom}
    enterTo={enterTo}
    {...(className && { className })}
  >
    {children}
  </Transition>
);
